import { z } from 'zod';

import {
  type IdentityBootstrapNextAction,
  identityBootstrapNextActionValues,
} from './bootstrap.dto.js';
import { ActiveCompanyContextSchema } from './active-company-context.schema.js';
import { CompanyMembershipSummarySchema } from '../tenancy/membership.schema.js';
import { UserSchema } from '../users/user.schema.js';
import { userStatusValues } from '../users/user.dto.js';

export const IdentityBootstrapNextActionSchema: z.ZodType<IdentityBootstrapNextAction> = z.enum(
  identityBootstrapNextActionValues,
);

export const IdentityBootstrapResponseSchema = z
  .object({
    mode: z.literal('identity'),
    user: UserSchema,
    memberships: z.array(CompanyMembershipSummarySchema),
    platformPermissions: z.array(z.string().trim()),
    nextAction: IdentityBootstrapNextActionSchema,
    autoSelectCompanyId: z.uuid().optional(),
  })
  .strict();

export const CompanyBootstrapResponseSchema = z
  .object({
    mode: z.literal('company'),
    user: UserSchema,
    memberships: z.array(CompanyMembershipSummarySchema),
    activeCompany: ActiveCompanyContextSchema,
    id: z.uuid(),
    email: z.string().trim().pipe(z.email()),
    status: z.enum(userStatusValues),
    platformPermissions: z.array(z.string().trim()).optional(),
    authzVersion: z.number().int().nonnegative(),
  })
  .strict();

export const BootstrapResponseSchema = z.discriminatedUnion('mode', [
  IdentityBootstrapResponseSchema,
  CompanyBootstrapResponseSchema,
]);
